import { ca } from '@cian/analytics';

export const trackBlackFridayBannerClick = () => trackBlackFridayBannerEvent('click_sopr');
export const trackBlackFridayBannerShow = () => trackBlackFridayBannerEvent('show_sopr');

function trackBlackFridayBannerEvent(action: 'show_sopr' | 'click_sopr') {
  ca('eventSite', {
    action,
    category: 'BlackFriday',
    label: 'to_object_listing',
    name: 'oldevent',
  });
}
